import { useAppStore } from '@/store/useAppStore.ts'
import { RangeSlider } from 'calc-controls'
import { HelpIcon } from '@/components/shared/HelpIcon.tsx'

export function EfficiencyInput() {
  const efficiency = useAppStore((s) => s.efficiency)
  const setEfficiency = useAppStore((s) => s.setEfficiency)
  const toggleEfficiency = useAppStore((s) => s.toggleEfficiency)

  return (
    <div className="efficiency-input">
      <div className="efficiency-input__header">
        <HelpIcon text="Accounts for converter and wiring losses. The effective load is divided by this efficiency, reducing calculated runtime.">
          <label className="efficiency-input__label">System Efficiency</label>
        </HelpIcon>
        <button
          type="button"
          className={`efficiency-input__toggle ${efficiency.includeEfficiency ? 'efficiency-input__toggle--active' : ''}`}
          onClick={toggleEfficiency}
          aria-pressed={efficiency.includeEfficiency}
          aria-label="Include efficiency derating"
        >
          {efficiency.includeEfficiency ? 'On' : 'Off'}
        </button>
      </div>
      {efficiency.includeEfficiency && (
        <RangeSlider
          label="Efficiency"
          value={Math.round(efficiency.efficiencyPercent * 100)}
          onChange={(v) => setEfficiency({ efficiencyPercent: v / 100 })}
          min={50}
          max={100}
          step={1}
          decimals={0}
          unit="%"
        />
      )}
      <p className="efficiency-input__description">{efficiency.description}</p>
    </div>
  )
}
